export const cashFlowTransactionQueryKeys = {
  id: 'id',
  amount: 'amount',
  type: 'operation',
  isTransfer: 'transfer',
  operatedAt: 'operation_date',
  cashRegister: {
    id: 'cashbox_id',
  },
  paymentType: {
    id: 'payment_type',
  },
  operation: {
    child: {
      id: 'cash_category_id',
    },
  },
  executor: {
    id: 'user_id',
  },
};
